/**
 * @type {string}
 * @description Custom attribute for showing or hiding the close icon.
 */
export const SHOW_CLOSE_ICON_ATTRIBUTE = 'show-close-icon';

/**
 * Event triggered to close the common custom modal.
 * @type {string} - The event name.
 */
export const TRIGGER_CLOSE_COMMON_CUSTOM_MODAL_EVENT =
    'trigger-close-common-custom-modal';

/**
 * @type {string}
 * @description - The custom modal web component.
 */
export const CUSTOM_COMMON_MODAL_WEB_COMPONENT = 'custom-common-modal-component';
